export default {
  coverage: 'Coverage',
  catalog: 'Catalogue',
  accounts: `Users & Teams`,
  giftbox: 'Features & Packages',
  banner: `Banner`,
  account: `Mon compte`,
  logout: `Déconnexion`,
};
